module.exports = __webpack_public_path__ + "img/page_4_pic.a330afce.png";